import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@mui/styles';
import Grid from '@mui/material/Grid';
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
import TextField from '@mui/material/TextField';
import { ExpandMore, Settings } from '@mui/icons-material';
import { isLockedOrder } from '../../utils/adManagerHelpers';

const styles = theme => ({
  leftIcon: {
    marginRight: theme.spacing(2)
  },
  displayInline: {
    display: 'inline'
  }
});

class PlacementBasicForm extends Component {
  render() {
    const {
      isNew,
      classes,
      placement,
      order,
      onChange,
      errors,
      itemRemainder
    } = this.props;

    let workflowState = '';
    if (isLockedOrder(order)) {
      workflowState += ' Finalized; changes may require Reopen';
    } else if (order && order.dfpReopenStatus === 'Reopened') {
      workflowState += ' Reopened proposal must be sent to buyer';
    }
    let foundCLT;
    if (!placement || !placement.LineItems || placement.LineItems.length === 0) {
      foundCLT = false;
    } else {
      foundCLT = (placement.LineItems.some(li => li.creativeTargetings && li.creativeTargetings !== '[]'));
    }
    const agencyName = (placement.packageId) ? `${placement.agencyPackageName} [${placement.packageId}]` : `${placement.agencyPackageName}`

    return (
      <Accordion defaultExpanded>
        <AccordionSummary expandIcon={<ExpandMore />}>
          <Settings className={classes.leftIcon} />
          <Typography variant="subtitle1">Names and IDs</Typography>
          <span>&nbsp; &nbsp; &nbsp; &nbsp;</span>
          <Typography variant="h6" className={classes.flex}>
            {!isNew ? placement.agencyPlacementName : `Create Placement`}
            {itemRemainder < 0 && (
              <div className={classes.displayInline}>
                <span>&nbsp; &nbsp; &nbsp; &nbsp;</span>
                <Chip label="Line items at limit: actions adding more are prevented" color="secondary" />
              </div>
            )}
            {foundCLT && (
              <div className={classes.displayInline}>
                <span>&nbsp; &nbsp; &nbsp; &nbsp;</span>
                <Chip label="Creative Level Targeting" color="error" />
              </div>
            )}
            {(order && order.orderType === 'Programmatic') && (
              <div className={classes.displayInline}>
                <span>&nbsp; &nbsp; &nbsp; &nbsp;</span>
                <Chip label='Programmatic' />
              </div>
            )}
            { workflowState && (
              <div className={classes.displayInline}>
                <span>&nbsp; &nbsp; &nbsp; &nbsp;</span>
                <Chip label={workflowState} color="secondary" />
              </div>
            )}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={3} direction="row">
            <Grid item xs={6}>
              <TextField
                variant="standard"
                name="agencyPackageName"
                value={agencyName}
                label="Agency Package Name"
                onChange={onChange}
                fullWidth
                disabled={!!placement.packageId}
                margin="normal" />
            </Grid>
            <Grid item xs={6}>
              <TextField
                variant="standard"
                name="agencyPlacementName"
                value={placement.agencyPlacementName || ''}
                label="Agency Placement Name"
                onChange={onChange}
                error={!!errors.agencyPlacementName}
                helperText={errors.agencyPlacementName}
                fullWidth
                margin="normal" />
            </Grid>
            {order && order.orderType !== 'Programmatic' &&
            (
            <Grid item xs={4}>
              <TextField
                variant="standard"
                name="agencyPlacementId"
                value={placement.agencyPlacementId || ''}
                label="Agency Placement Id"
                onChange={onChange}
                error={!!errors.agencyPlacementId}
                helperText={errors.agencyPlacementId}
                fullWidth
                margin="normal" />
            </Grid>
            )}
            {order && order.orderType !== 'Programmatic' &&
            (
            <Grid item xs={4}>
              <TextField
                variant="standard"
                name="agencyBillingId"
                value={placement.agencyBillingId || ''}
                label="Agency Billing Id"
                onChange={onChange}
                error={!!errors.agencyBillingId}
                helperText={errors.agencyBillingId}
                fullWidth
                margin="normal" />
            </Grid>
            )}
            {order && order.orderType !== 'Programmatic' &&
            (
            <Grid item xs={4}>
              <TextField
                variant="standard"
                name="billingGroup"
                value={placement.billingGroup || ''}
                label="Billing Group"
                onChange={onChange}
                error={!!errors.billingGroup}
                helperText={errors.billingGroup}
                fullWidth
                margin="normal" />
            </Grid>
            )}
            <Grid item xs={8}>
              <TextField
                variant="standard"
                name="comments"
                value={placement.comments || ''}
                label="Ad Name Comments"
                onChange={onChange}
                error={!!errors.comments}
                helperText={errors.comments}
                fullWidth
                margin="normal" />
            </Grid>

            <Grid item xs={4}>
              <TextField
                variant="standard"
                name="gComments"
                value={placement.gComments || ''}
                label="Galileo Comments"
                onChange={onChange}
                error={!!errors.gComments}
                helperText={errors.gComments}
                fullWidth
                margin="normal" />
            </Grid>

          </Grid>
        </AccordionDetails>
      </Accordion>
    );
  }
}

PlacementBasicForm.defaultProps = {
  order: null
};

PlacementBasicForm.propTypes = {
  classes: PropTypes.object.isRequired,
  placement: PropTypes.object.isRequired,
  order: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired
};

export default withStyles(styles)(PlacementBasicForm);
